import React, { useState } from "react";
import { QqControlsGroupPropsType } from "./qq-controls-group-props.type";
import { QqControlFactory } from "./qq-control-factory";
import { Box, Link } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Collapse from "@mui/material/Collapse";
import { useStyles } from "../utils/styles.hook";
import { LinkTypography } from "./qq-typohraphy.controls";
import { QqBundleService } from "../services/qq-bundle.service";

export const QqControlsGroupAdditionalControl: React.FunctionComponent<QqControlsGroupPropsType> =
  ({ group, state, dispatch }) => {
    const classes = useStyles();
    const [visible, setVisible] = useState<boolean>(false);
    const ctrlFactory = new QqControlFactory();
    const qqBundleService = new QqBundleService(state.qqBundle);
    const final = qqBundleService.getFinalQuestionIfExist(state.currentOptions);

    const controls = group.qq
      .map((qq) => {
        if (final && qq.orderNumber > final.orderNumber) return undefined;
        return ctrlFactory.create({ state, dispatch }, qq);
      })
      .reduce((r: any, v: any) => {
        if (v) r.push(v);
        return r;
      }, []);

    if (controls.length === 0) return <div />;

    return (
      <React.Fragment>
        {!visible && (
          <Box
            sx={{
              marginTop: "24px",
            }}
          >
            <Link underline={"none"} onClick={() => setVisible(!visible)}>
              <LinkTypography
                className={`${classes.wrapIcon} ${classes.cursorPointer}`}
              >
                {!visible ? (
                  <ExpandMore fontSize={"small"} />
                ) : (
                  <ExpandLess fontSize={"small"} />
                )}
                {group.label}
              </LinkTypography>
            </Link>
          </Box>
        )}
        <Collapse in={visible} timeout="auto">
          {controls}
          <Box
            sx={{
              marginTop: "24px",
            }}
          >
            <Link underline={"none"} onClick={() => setVisible(false)}>
              <LinkTypography
                className={`${classes.wrapIcon} ${classes.cursorPointer}`}
              >
                <ExpandLess fontSize={"small"} />
                Less
              </LinkTypography>
            </Link>
          </Box>
        </Collapse>
      </React.Fragment>
    );
  };
